import styled from "styled-components";

export const HeroWrapper = styled.section`
  background: linear-gradient(
    110deg,
    ${({ theme }) => theme.colors.lightAmber},
    ${({ theme }) => theme.colors.amber}
  );
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.extraLarge}
    ${({ theme }) => theme.borderRadius.extraLarge};
  padding: ${({ theme }) => theme.spacing(15)} 0 ${({ theme }) => theme.spacing(7.5)};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme }) => theme.spacing(7.5)} 0;
    border-radius: 0 0 2.5rem 2.5rem;
  }
`;

export const HeroInner = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 80%;
  }
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

export const HeroTop = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(10)};
  }
`;

/** Ilustração do design; escondida no mobile para manter a barra no topo. */
export const HeroArt = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: block;
    flex: 0 0 34%;
    max-width: 34%;

    & svg {
      display: block;
      width: 100%;
      height: auto;
    }
  }
`;

export const HeroText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
  max-width: 36rem;
`;

export const HeroTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: 1.8rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.2;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 3.1rem;
  }
`;

/** Sino do design (SVG exportado, já branco). */
export const BellIcon = styled.span`
  display: inline-flex;
  width: ${({ theme }) => theme.spacing(8)};

  & svg {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const HeroSubtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.primary}, sans-serif;
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.normal};
  line-height: 1.4;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    font-size: 1.5rem;
  }
`;

/**
 * Slot da barra. No desktop fica mais largo que o texto (110% de 80% = 88%
 * da tela), igual à barra de busca da home, e é centralizado.
 */
export const HeroSlot = styled.div`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 110%;
    align-self: center;
  }
`;
